import { Fragment, useEffect, useCallback, memo } from "react";
import { Button } from "core/components/form-controls";
import BottomSwiper from "core/components/BottomSwiper";
import { _t } from "core/language";
import Icon from 'core/assets/icons';
import { CImagePicker } from "core/components/form-controls";
import { ImageTypeEnums, OpenImagePickerType } from "core/store/upload/actions";
import { useGetImagePicker } from "core/hooks/useImagePicker";

const SelectSwiper = ({
  setIsDrawerOpen,
  isDrawerOpen,
  type = 'communityImages',
}: any) => {
  const communityImages = useGetImagePicker(type, true)

  const onOpen = () => setIsDrawerOpen(true);
  const onClose = () => {
    setIsDrawerOpen(false);
  }

  const toggleDrawer = useCallback(() => {
    if (isDrawerOpen) {
      onClose()
    } else {
      onOpen()
    }
  }, [isDrawerOpen]);

  useEffect(() => {
    // close swiper after selecting images
    if (communityImages?.length) {
      onClose();
    }
  }, [communityImages?.length])

  return (
    <Fragment>
      <BottomSwiper
        isOpen={isDrawerOpen}
        toggleDrawer={toggleDrawer}
        zIndex={50}
      >
        <div className="flex flex-col gap-3">
          <CImagePicker
            name={type}
            multiple
            property={ImageTypeEnums.COMMUNITY}
            openType={OpenImagePickerType.CAMERA}
            hideRemoveIcon
            component={{
              input: <Button
                label={_t('comunity.create.add_image_by_camera')}
                classBtn="w-full [box-shadow:none!important]"
                primary
                icon={Icon.RecipeSelectImageByCamera}
              />,
              loading: <div></div>,
              preview: () => 
                <div></div>
            }}
          />
          <CImagePicker
            name={type}
            multiple
            property={ImageTypeEnums.COMMUNITY}
            openType={OpenImagePickerType.GALLERY}
            hideRemoveIcon
            component={{
              input: <Button
                label={_t('comunity.create.add_image_by_gallery')}
                classBtn="w-full"
                primary
                outline
                icon={Icon.RecipeSelectImageByGallery}
              />,
              loading: <div></div>,
              preview: () => 
                <div></div>
            }}
            maxFile={10 - communityImages?.length}
          />

          <CImagePicker
            name={type}
            multiple
            property={ImageTypeEnums.COMMUNITY}
            openType={OpenImagePickerType.CAMERA}
            fileType="VIDEO"
            hideRemoveIcon
            component={{
              input: <Button
                label={_t('comunity.create.add_video_by_camera')}
                classBtn="w-full [box-shadow:none!important]"
                primary
                icon={Icon.RecipeSelectImageByCamera}
              />,
              loading: <div></div>,
              preview: () => <div></div>
            }}
          />
          <CImagePicker
            name={type}
            multiple
            property={ImageTypeEnums.COMMUNITY}
            openType={OpenImagePickerType.GALLERY}
            fileType="VIDEO"
            hideRemoveIcon
            component={{
              input: <Button
                label={_t('comunity.create.add_video_by_gallery')}
                classBtn="w-full"
                primary
                outline
                icon={Icon.RecipeSelectImageByGallery}
              />,
              loading: <div></div>,
              preview: () => <div></div>
            }}
            maxFile={10 - communityImages?.length}
          />
        </div>
      </BottomSwiper>
    </Fragment>
  )
}

export default memo(SelectSwiper)
